import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook som leser innstillingen 'picking.autoCreatePalletOnDPakScan'.
 * Styrer om et D-pak-skann i plukk skal opprette pall (SSCC) automatisk.
 *
 * Når på: skann som inneholder GTIN + batch og/eller holdbarhet tolkes som D-pak.
 * Compass genererer SSCC, oppretter OrderSSCC-rad med batch/holdbarhet/antall fra
 * etiketten, øker QtyPicked og printer pall-etiketten — uten dialoger. Skann uten
 * D-pak-innhold faller tilbake til vanlig plukkflyt (blandede ordrer støttes).
 *
 * Settes på system- OG profilnivå (AllowProfileLevel=true), så getEffectiveSetting
 * brukes for å respektere hierarkiet (Profile → System → Default).
 *
 * Default: false (bakoverkompatibelt — ingen tenant endrer oppførsel før den
 * eksplisitt slås på).
 *
 * Se «Claude md files/D-Pak-Pall-Nivaa3/Plan.md».
 */
export function useAutoCreatePalletOnDPakScan(): boolean {
  const [enabled, setEnabled] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getEffectiveSetting('picking.autoCreatePalletOnDPakScan');
        if (!cancelled) {
          if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
            const val = setting.currentValue.toString().toLowerCase();
            setEnabled(val === 'true' || val === '1' || val === 'ja');
          } else {
            // Ingen verdi satt → bruk default (av)
            setEnabled(false);
          }
        }
      } catch (err) {
        console.warn('Could not load picking.autoCreatePalletOnDPakScan setting, defaulting to false:', err);
        if (!cancelled) {
          setEnabled(false);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return enabled;
}
